module.exports = __webpack_public_path__ + "media/960bn1.d29dab44.mp4";